/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { mq } from '../../../../helpers'
import Color from 'color'
import { gsColors } from '../../../../styles/Variables'
import { useRouter } from 'next/router'
import Nav from '../../../nav'

const BookingStepHeader = styled.header`
  background-color: ${gsColors.white};
  box-shadow: 0 0 5px 0 ${Color(gsColors.black).alpha(0.1).string()};
  position: relative;

  ${mq('min', '768px')} {
    width: 100vw;
  }

  &:before {
    background-color: ${gsColors.progressBar};
    content: '';
    position: absolute;
    top: 60px;
    left: 0;
    transform: scaleX(${props => (props.straightToService ? (props.step - 1) / 4 : props.step / 5)});
    transform-origin: left;
    transition: transform 500ms cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    height: 12px;
    z-index: -10;

    ${mq('min', '768px')} {
      top: 92px;
    }
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 100%;
    margin: 0 auto;
    max-width: 1440px;
    position: relative;

    ${mq('min', '768px')} {
      padding: 0 88px;
      height: 92px;
    }
  }

  .gs-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
      width: 175px;
      height: auto;

      ${mq('min', '768px')} {
        width: 320px;
      }
    }
  }

  .round-close-button {
    position: absolute;
    padding-left: 32px;
    border: none;
    background-color: transparent;
    right: 88px;
    cursor: pointer;

    ${mq('max', '768px')} {
      right: 16px;
      
      img {
        transform: scale(0.8);
      }
    }
  }

  .round-back-button {
    position: absolute;
    padding-right: 32px;
    border: none;
    background-color: transparent;
    left: 88px;
    cursor: pointer;

    ${mq('max', '768px')} {
      left: 16px;
      
      img {
        transform: scale(0.8);
      }
    }
  }
`
const BookingFlowHeader = ({ prev, referrer, step, straightToService }) => {
  let prevPage = '/'

  const router = useRouter()

  if (
    referrer?.hostname?.includes('glamsquad.com') &&
    referrer?.pathname !== '/'
  ) {
    prevPage = referrer?.pathname
  }

  const goToPreviousPage = () => {
    router.push(prevPage)
  }

  if (step === 6) {
    return (
      <Nav forcedShow={true} />
    )
  }

  return (
    <BookingStepHeader step={step} straightToService={straightToService}>
      <div className="container">
        {prev && (
          <button
            aria-label='Back'
            className='round-back-button'
            onClick={prev}
          >
            <img src='/images/book-back-arrow.svg' alt='' aria-hidden='true' />
          </button>
        )}
        <Link legacyBehavior href='/'>
          <a aria-label="gsLogo" className="gs-logo">
            <img src='/images/new-gs-wordmark-logo.svg' width="320" height="44" alt='Glamsquad logo' />
          </a>
        </Link>
        <button
          aria-label="close-button"
          className="round-close-button"
          onClick={goToPreviousPage}
        >
          <img src='/images/booking-header-close.svg' alt='close button' />
        </button>
      </div>
    </BookingStepHeader>
  )
}

export default BookingFlowHeader
